// Accordion menu JS for @linklist.liquid

document.addEventListener('DOMContentLoaded', function () {
  // Assign unique IDs to accordion content and link them to toggles
  document.querySelectorAll('.accordion-content').forEach(function (content, idx) {
    if (!content.id) {
      content.id = 'accordion-content-' + idx;
    }
    const li = content.closest('li');
    const btn = li.querySelector('.accordion-toggle');
    if (btn) {
      btn.setAttribute('aria-controls', content.id);
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
    }
  });

  // Toggle logic
  document.querySelectorAll('.accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleAccordion(btn);
    });
  });

  function toggleAccordion(btn) {
    const li = btn.closest('li');
    const content = li.querySelector('.accordion-content');
    const expanded = li.classList.toggle('open');
    btn.setAttribute('aria-expanded', expanded);
    if (content) {
      if (expanded) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0px';
      }
    }
  }

  // Initialize all accordion-content max-heights and aria-expanded
  document.querySelectorAll('.accordion-content').forEach(function (el) {
    const li = el.closest('li');
    const btn = li.querySelector('.accordion-toggle');
    if (li.classList.contains('open')) {
      el.style.maxHeight = el.scrollHeight + 'px';
      if (btn) btn.setAttribute('aria-expanded', 'true');
    } else {
      el.style.maxHeight = '0px';
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  });
});